import { useSEO } from '../lib/seo';
import { SITE } from '../lib/site';
import { Hero } from '../sections/Hero';
import { MarqueeBand } from '../components/MarqueeBand';
import { Features } from '../sections/Features';
import { Showcase } from '../sections/Showcase';
import { Benefits } from '../sections/Benefits';
import { HowItWorks } from '../sections/HowItWorks';
import { Pricing } from '../sections/Pricing';
import { Integrations } from '../sections/Integrations';
import { Testimonials } from '../sections/Testimonials';
import { Faq } from '../sections/Faq';
import { CtaBanner } from '../sections/CtaBanner';

export const Home = () => {
  useSEO({ title: 'CapableBee — AI Voice Assistant for Business Calls', description: SITE.description });

  return (
    <>
      <Hero />
      <MarqueeBand />
      <Features />
      <Showcase />
      <Benefits />
      <HowItWorks />
      <Pricing />
      <Integrations />
      <Testimonials />
      <Faq />
      <CtaBanner />
    </>
  );
};
